export const scheduleQueryOptions = {
  refetchOnMountOrArgChange: true,
  refetchOnFocus: false,
  refetchOnReconnect: true,
} as const

export const scheduleGridQueryOptions = {
  refetchOnMountOrArgChange: true,
  refetchOnFocus: false,
  refetchOnReconnect: true,
} as const

export const scheduleProfileQueryOptions = {
  refetchOnMountOrArgChange: true,
  refetchOnFocus: false,
  refetchOnReconnect: true,
} as const
